<template>
	<div
		v-if="patient && intake_form"
		class="w-full"
	>
		<div
			v-if="print_component"
			class="col-12 text-center"
		>
			<h1 style="margin-bottom: 1rem">COMPROVANTE DE AGENDAMENTO</h1>
		</div>
		<div class="border bg-light rounded-lg w-100">
			<div class="px-4 py-3">
				<div class="row">
					<div
						class="col-12"
						v-if="!print_component"
					>
						<div
							v-if="patient"
							class="row mb-3"
						>
							<div class="col-3 col-md-auto mb-4 d-flex flex-column align-items-center">
								<img
									:src="avatar"
									class="rounded-lg border border-secondary patient-avatar"
								/>
							</div>
							<div class="col">
								<div class="row">
									<h4 class="m-0 mb-3 font-20">
										{{ patient.name }}
									</h4>
								</div>
								<div class="row">
									<p class="mb-0">
										RG:
										<span :class="patient.rg ? 'font-weight-bold' : 'unknown'">{{
											patient.rg ? patient.rg.toUpperCase() : 'DESCONHECIDO'
										}}</span>
										<span
											v-if="patient.rg_uf != 'DESCONHECIDO'"
											:class="patient.rg_uf ? 'font-weight-bold' : 'unknown'"
											>{{ patient.rg_uf ? patient.rg_uf.toUpperCase() : '' }}</span
										>
									</p>
									<p class="mb-0">
										CPF:
										<span :class="patient.cpf ? 'font-weight-bold' : 'unknown'">{{
											patient.cpf ? patient.cpf.toUpperCase() : 'DESCONHECIDO'
										}}</span>
									</p>
									<p class="mb-0">
										CNS:
										<span :class="patient.sus ? 'font-weight-bold' : 'unknown'">{{
											patient.sus ? patient.sus.toUpperCase() : 'DESCONHECIDO'
										}}</span>
									</p>
									<p class="mb-0">
										RH:
										<span :class="patient.rh ? 'font-weight-bold' : 'unknown'">{{
											patient.rh ? patient.rh.toUpperCase() : 'DESCONHECIDO'
										}}</span>
									</p>
								</div>
								<div class="row my-2">
									<div class="px-0">
										DATA DE NASCIMENTO:
										<span
											:class="
												patient_birthdate !== 'DESCONHECIDO' ? 'font-weight-bold' : 'unknown'
											"
											>{{ patient_birthdate }}</span
										>
										<span
											v-if="patient.date_of_birth"
											:class="patient_age ? 'font-weight-bold' : 'unknown'"
										>
											({{ patient_age }})</span
										>
									</div>
									<div class="px-0">
										SEXO:
										<span :class="patient.sex ? 'font-weight-bold' : 'unknown'">{{
											patient.sex
												? patient.sex === 'M'
													? 'MASCULINO'
													: 'FEMININO'
												: 'DESCONHECIDO'
										}}</span>
									</div>
									<div class="px-0">
										TELEFONE:
										<span :class="patient.cellphone ? 'font-weight-bold' : 'unknown'">{{
											patient.cellphone ?? 'DESCONHECIDO'
										}}</span>
									</div>
									<div
										v-if="is_endoscopy_modality && patient.mother_name"
										class="px-0"
									>
										NOME MÃE:
										<span class="mb-0"
											><b>{{ patient.mother_name }}</b></span
										>
									</div>
								</div>
								<div class="row">
									<div
										v-if="partnership"
										class="px-0"
									>
										CONVÊNIO:
										<span class="mb-0"
											><b>{{ partnership.toUpperCase() }}</b></span
										>
									</div>
									<div class="px-0">
										SOLICITANTE:
										<span :class="indicator ? 'font-weight-bold' : 'unknown'">{{
											indicator ? indicator.toUpperCase() : 'DESCONHECIDO'
										}}</span>
									</div>
								</div>
								<div class="row">
									<div
										v-if="patient.desconhecido"
										class="px-0"
									>
										<b class="text-danger"
											>! DADOS PESSOAIS E DOCUMENTOS DO PACIENTE NÃO VALIDADOS !</b
										>
									</div>
									<div
										v-else-if="patient.newborn"
										class="px-0"
									>
										<b class="text-danger"
											>! RECÉM-NASCIDO SEM DOCUMENTOS OFICIAIS DISPONÍVEIS PARA CADASTRO !</b
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="intake_form"
						class="col-12"
					>
						<div class="pb-0">
							<div
								v-if="!print_component"
								class="col-12 text-center"
							>
								<h1>COMPROVANTE DE AGENDAMENTO</h1>
							</div>
							<template>
								<div class="mb-3">
									<div class="col-12 text-center mb-3 p-0">
										<h2>DADOS DO AGENDAMENTO</h2>
									</div>
									<div class="row align-items-center">
										<div class="col text-dark">
											<div>
												<p class="mb-0 h4-size">
													PROCEDIMENTO:
													<b>{{ intake_form.modality }}</b>
												</p>
											</div>
											<div v-if="intake_form.origin === ORIGINS.SCHEDULING_URGENT_APPOINTMENT">
												<p class="mb-0 h4-size">
													DATA:
													<b>{{ parsed_date }}</b>
												</p>
											</div>
											<div
												v-else-if="
													intake_form.origin === ORIGINS.FIT || scheduling.is_fit_no_show
												"
											>
												<p class="mb-0 h4-size">
													DATA:
													<b
														>{{ parsed_date }}
														{{ parsed_time }}
														[ENCAIXE]</b
													>
												</p>
											</div>
											<div v-else>
												<p class="mb-0 h4-size">
													DATA:
													<b>{{ parsed_date }}</b>
												</p>
											</div>
											<p class="mb-0 h4-size">
												HORÁRIO:
												<b>{{ parsed_time }}</b>
											</p>
											<p class="mb-0 h4-size">
												AGENDA:
												<b>{{ intake_form.schedule.name.toUpperCase() }}</b>
											</p>
										</div>
										<div
											class="d-flex flex-column"
											style="padding-left: 15px; padding-right: 15px"
											v-if="patient.patient_code"
										>
											<a
												:href="patientPortalUrl"
												rel="noopener"
												target="_blank"
												style="
													border: 1px solid var(--hr);
													padding: 0.5rem;
													border-radius: 1rem;
													background-color: #fff;
												"
											>
												<qrcode-vue
													:text="patientPortalUrl"
													:size="122"
													class="max-150 rounded-lg"
												/>
											</a>
										</div>
									</div>
								</div>
							</template>
							<hr />
							<div class="mt-0">
								<div class="row mb-3">
									<div class="col-12 text-center mb-3">
										<h2>PROCEDIMENTOS AGENDADOS</h2>
									</div>
									<div
										class="col-12 text-dark h4-size"
										v-for="(proceeding, index) in intake_form.proceedings"
										:key="index"
									>
										<div v-if="proceeding">
											<p class="mb-0">
												<b>({{ index + 1 }}): {{ proceeding.name }}</b>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="intake_form?.proceedings?.length > 0 && has_instruction"
			class="border bg-light rounded-lg w-100 separate-cards"
		>
			<div class="p-3">
				<div class="">
					<div class="mb-0">
						<div class="col-12 text-center mb-3">
							<h2>INSTRUÇÕES</h2>
						</div>
						<template v-if="has_compiled_instructions">
							<div v-html="normalized_compiled_instructions"></div>
						</template>
						<template v-else>
							<div
								v-for="(instruction, index) in allInstructions"
								:key="instruction.key"
								class="col-12 text-dark instructions-list"
							>
								<div class="col-12 p-0 instruction-item">
									<hr
										v-if="index > 0"
										style="margin-top: 0.5rem; margin-bottom: 0.5rem"
									/>
									<div
										class="mb-0 h6-size"
										v-html="instruction.html"
									></div>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="type === 'scheduling'"
			class="border bg-light rounded-lg w-100 separate-cards"
		>
			<div class="p-4">
				<div class="form-group">
					<textarea
						v-debounce:500="DelayFillObs"
						class="form-control text-dark"
						placeholder="Observações"
						v-model="form.obs"
					/>
				</div>
			</div>
		</div>
		<div
			v-else-if="intake_form && intake_form.obs !== null"
			class="border bg-light rounded-lg w-100 separate-cards"
		>
			<div class="p-4">
				<div class="w-full">
					<div class="col-12 text-dark p-0">
						<p class="mb-0 h6-size"><b>Obs.: </b>{{ intake_form.obs }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swal from 'sweetalert2'
	import { mapGetters, mapActions } from 'vuex'
	import moment from 'moment'
	import QrcodeVue from 'vue-qrcode-component'

	export default {
		name: 'SchedulingCard',
		components: {
			QrcodeVue,
		},
		props: {
			type: {
				type: String,
				default: 'consult',
			},
			scheduling_base: {
				type: Object,
				default: () => {},
			},
			attendance_id: {
				type: [String, Number],
				default: null,
			},
			print_component: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				ORIGINS: {
					SCHEDULING_PRE_APPOINTMENT: 2,
					SCHEDULING_URGENT_APPOINTMENT: 3,
					FIT: 4,
				},
				scheduling: null,
				intake_form: null,
				patient: null,
				defaultAvatar: window.defaultAvatar,
				form: {
					obs: '',
				},
				payment_methods_info: {
					methods: [],
					discount: null,
					total: null,
				},
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			avatar() {
				return this.patient && this.patient.avatar ? this.patient.avatar : this.defaultAvatar
			},
			doc_id() {
				if (this.patient.doc_id.tipo) {
					return `${this.patient.doc_id.tipo.toUpperCase()} ${this.patient.doc_id.numero.toUpperCase()}`
				} else {
					return `${this.patient.doc_id}`
				}
			},
			has_compiled_instructions() {
				const vm = this
				if (!vm.intake_form) return false

				return (
					vm.intake_form.proceedings[0].instructions &&
					typeof vm.intake_form.proceedings[0].instructions === 'string' &&
					vm.intake_form.proceedings[0].instructions.includes('instructions-list')
				)
			},
			normalized_compiled_instructions() {
				const vm = this
				if (!vm.has_compiled_instructions) return ''

				const rawHtml = vm.intake_form.proceedings[0].instructions

				if (rawHtml.includes('col-12 text-dark instructions-list')) {
					return rawHtml
				}

				const parser = new DOMParser()
				const doc = parser.parseFromString(`<div>${rawHtml}</div>`, 'text/html')
				const instructionLists = doc.querySelectorAll('.instructions-list')

				let result = ''
				let isFirst = true

				instructionLists.forEach(list => {
					const item = list.querySelector('.instruction-item')
					if (!item) return

					const title = item.querySelector('.instruction-title')?.outerHTML || ''
					const content = item.innerHTML.replace(title, '').trim()

					const hr = isFirst ? '' : '<hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;"/>'
					isFirst = false

					result += `<div class="col-12 text-dark instructions-list"><div class="col-12 p-0 instruction-item">${hr}<div class="mb-0 h6-size">${content}</div></div></div>`
				})

				return result
			},
			has_instruction() {
				const vm = this

				if (!vm.intake_form) return false

				if (vm.has_compiled_instructions) return true

				if (vm.intake_form.organization_instructions) return true
				if (vm.intake_form.module_instructions) return true
				if (vm.intake_form.modality_instructions) return true

				if (vm.intake_form.group_instructions?.length > 0) {
					if (vm.intake_form.group_instructions.some(g => g && g.instructions)) return true
				}

				if (vm.intake_form.subgroup_instructions?.length > 0) {
					if (vm.intake_form.subgroup_instructions.some(s => s && s.instructions)) return true
				}

				if (vm.intake_form?.proceedings?.length) {
					return !!vm.intake_form.proceedings.filter(p => p && !!p.instructions).length
				}

				return false
			},
			hierarchicalProceedingInstructions() {
				const vm = this

				if (!vm.intake_form?.proceedings?.length) return []

				const groupsMap = new Map()
				const subgroupsMap = new Map()

				if (vm.intake_form.group_instructions?.length) {
					vm.intake_form.group_instructions.forEach(g => {
						if (g && g.id) groupsMap.set(g.id, g)
					})
				}

				if (vm.intake_form.subgroup_instructions?.length) {
					vm.intake_form.subgroup_instructions.forEach(s => {
						if (s && s.id) subgroupsMap.set(s.id, s)
					})
				}

				const hierarchy = new Map()

				vm.intake_form.proceedings.forEach(proc => {
					const subgroupId = proc.parent_id
					const subgroup = subgroupsMap.get(subgroupId)
					const groupId = subgroup?.parent_id || null
					const group = groupsMap.get(groupId)

					const groupKey = groupId || 'no-group'
					const subgroupKey = subgroupId || 'no-subgroup'

					if (!hierarchy.has(groupKey)) {
						hierarchy.set(groupKey, {
							group: group,
							subgroups: new Map(),
						})
					}

					const groupEntry = hierarchy.get(groupKey)

					if (!groupEntry.subgroups.has(subgroupKey)) {
						groupEntry.subgroups.set(subgroupKey, {
							subgroup: subgroup,
							proceedings: [],
						})
					}

					groupEntry.subgroups.get(subgroupKey).proceedings.push(proc)
				})

				const result = []

				hierarchy.forEach((groupEntry, groupKey) => {
					const groupItem = {
						group: groupEntry.group,
						subgroups: [],
					}

					groupEntry.subgroups.forEach((subgroupEntry, subgroupKey) => {
						groupItem.subgroups.push({
							subgroup: subgroupEntry.subgroup,
							proceedings: subgroupEntry.proceedings,
						})
					})

					result.push(groupItem)
				})

				return result
			},
			allInstructions() {
				const vm = this

				if (!vm.intake_form) return []

				const items = []

				const sources = [
					{
						key: 'organization',
						html: vm.intake_form.organization_instructions,
					},
					{ key: 'module', html: vm.intake_form.module_instructions },
					{
						key: 'modality',
						html: vm.intake_form.modality_instructions,
					},
				]

				sources.forEach(s => {
					if (s.html) items.push(s)
				})

				vm.hierarchicalProceedingInstructions.forEach((groupItem, gIndex) => {
					if (groupItem.group?.instructions) {
						items.push({
							key: 'group-' + gIndex,
							html: groupItem.group.instructions,
						})
					}

					groupItem.subgroups.forEach((subgroupItem, sIndex) => {
						if (subgroupItem.subgroup?.instructions) {
							items.push({
								key: 'group-' + gIndex + '-subgroup-' + sIndex,
								html: subgroupItem.subgroup.instructions,
							})
						}

						subgroupItem.proceedings.forEach((proc, pIndex) => {
							if (proc?.instructions) {
								items.push({
									key: 'group-' + gIndex + '-subgroup-' + sIndex + '-proc-' + pIndex,
									html: proc.instructions,
								})
							}
						})
					})
				})

				return items
			},
			attendance_time() {
				const vm = this

				return vm.intake_form.schedule.time_attendance || 0
			},
			attendance_string() {
				const vm = this

				if (vm.intake_form.origin === vm.ORIGINS.SCHEDULING_PRE_APPOINTMENT) {
					const attendance_time = moment(vm.intake_form.scheduling_date_time).subtract(
						vm.attendance_time,
						'minutes'
					)

					const time = {
						dia: moment(vm.intake_form.scheduling_date_time).format('DD/MM/YYYY'),
						hora: moment(attendance_time).format('HH:mm'),
					}

					if (time.dia && time.hora) {
						return `${time.dia} às ${time.hora}`
					}
				}

				return ''
			},
			parsed_date() {
				const vm = this

				if (vm.intake_form.scheduling_date_time) {
					return moment(vm.intake_form.scheduling_date_time).format('DD/MM/YYYY')
				}

				return ''
			},
			parsed_time() {
				const vm = this

				if (vm.intake_form.scheduling_date_time) {
					return moment(vm.intake_form.scheduling_date_time).format('HH:mm')
				}

				return ''
			},
			is_endoscopy_modality() {
				const ENDOSCOPY_MODALITY_ID = 27

				return (
					this.intake_form?.proceedings?.filter(p => p.modality_id == ENDOSCOPY_MODALITY_ID).length > 0 ??
					false
				)
			},
			patient_birthdate() {
				let birthdate = 'DESCONHECIDO'

				if (!this.patient.date_of_birth) return birthdate

				birthdate = moment(this.patient.date_of_birth).format('DD/MM/YYYY')

				return birthdate
			},
			patient_age() {
				if (this.patient?.date_of_birth) {
					const dob = moment(this.patient.date_of_birth, 'YYYY-MM-DD')
					const today = moment()

					const years = today.diff(dob, 'year')
					dob.add(years, 'years')

					const months = today.diff(dob, 'months')
					dob.add(months, 'months')

					const days = today.diff(dob, 'days')

					let result = ''

					if (years > 0) {
						result = `${years} ANO${years > 1 ? 'S' : ''}`
					} else if (years === 0 && months > 0) {
						result = `${months} MES${months > 1 ? 'ES' : ''} e ${days} DIA${days > 1 ? 'S' : ''}`
					} else if (months === 0 && days > 0) {
						result = `${days} DIA${days > 1 ? 'S' : ''}`
					} else {
						result = '0 DIAS'
					}

					return result
				} else {
					return 'DESCONHECIDO'
				}
			},
			patientPortalUrl() {
				const base =
					process && process.env && process.env.VUE_APP_PORTAL_URL ? process.env.VUE_APP_PORTAL_URL : ''

				if (!this.patient) return ''

				const code = this.patient.patient_code || ''

				return `${base.replace(/\/$/, '')}/resultados?codigo=${encodeURIComponent(code)}`
			},
		},
		watch: {
			scheduling_base: {
				immediate: true,
				deep: true,
				handler(val) {
					if (val) {
						const schedulingCopy = JSON.parse(JSON.stringify(val))
						this.PopulateIntakeForm(schedulingCopy)
					}
				},
			},
			attendance_id: {
				async handler(val) {
					if (val) {
						await this.GetScheduling()
					}
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			PopulateIntakeForm(scheduling) {
				const vm = this

				if (scheduling) {
					vm.scheduling = scheduling
					vm.intake_form = vm.scheduling.intake_form
					vm.patient = vm.scheduling.header.patient
					vm.partnership = vm.scheduling.header.partnership
					vm.indicator = vm.scheduling.header.indicator
					vm.payment_methods_info = vm.scheduling.payment_info

					vm.$emit('update-payment-info', vm.payment_methods_info)
				}

				// TODO: Fazer a parte de pagamento.

				// this.$emit('update-indicator', vm.scheduling_data.indicator)
			},
			async GetScheduling() {
				const vm = this

				if (vm.attendance_id) {
					vm.StartLoading()

					return await window.api
						.call('post', '/get-attendances', {
							account_id: vm.requester_selected_id,
							attendance_id: vm.attendance_id,
						})
						.then(({ data }) => {
							if (data.response) {
								vm.scheduling = null

								if (data.scheduling) {
									vm.PopulateIntakeForm(data.scheduling)

									this.$emit('update-attendance', data.scheduling)
								}
							} else {
								Swal.fire({
									icon: 'error',
									text: 'Houve um erro ao obter, contate o suporte.',
									title: 'Opss...',
								})
							}
						})
						.finally(() => {
							vm.FinishLoading()
						})
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Dados não informados',
						text: 'São necessários os dados para a impressão do comprovante',
					})
				}
			},
			DelayFillObs() {
				const vm = this

				vm.scheduling.obs = vm.form.obs

				vm.$emit('update-obs', vm.scheduling.obs)
			},
		},
	}
</script>

<style lang="css" scoped>
	.row {
		gap: 0px 10px;
	}

	.separate-cards {
		margin-top: 2rem;
	}

	.h4-size {
		font-size: 1.4rem;
	}

	.h6-size {
		font-size: 1rem;
	}

	.tab-1 {
		tab-size: 2;
	}

	textarea {
		resize: none;
	}

	.patient-avatar {
		height: 80px;
	}

	@media (min-width: 768px) {
		.patient-avatar {
			height: 140px;
		}
	}

	.subtitle {
		font-size: 1.6rem;
		font-weight: bold;
		margin-bottom: 0.5rem;
	}

	.instruction-title {
		font-size: 1rem;
		font-weight: bold;
		margin-bottom: 0.25rem;
		color: #ebcb3e;
	}

	.border {
		border: 1px solid var(--dark-light) !important;
	}

	hr {
		border-color: var(--dark-light);
	}

	::v-deep .instruction-item p {
		margin-bottom: 0 !important;
	}
</style>
